import { ReflectionRoleEnum } from './reflection-role-enum'

export interface MulitiReflectionInterface {
  id: number
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 头像
   */
  avator?: string | null
  role: ReflectionRoleEnum
}

export class MulitiReflection implements MulitiReflectionInterface {
  id: number
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 头像
   */
  avator?: string | null
  role: ReflectionRoleEnum

  constructor(props: MulitiReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      name: _name,
      account: _account,
      avator: _avator,
      role: _role,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.name = _name
    this.account = _account
    this.avator = _avator
    this.role = _role
  }
}
